import IconButton from '@mui/material/IconButton';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import tooltip from "../../assets/images/icons/tooltip.svg"
import { styled } from '@mui/material/styles';
import parse from 'html-react-parser';

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip enterTouchDelay={0} {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#ffffff",
      color: '#888888',
      boxShadow: theme.shadows[1],
      fontSize: 16,
      fontWeight: 400,
      padding: "20px",
      '& a': {  // Targeting anchor tags inside the tooltip
       color: 'black',  // Making them black
     },
    },
  }));

export default function CustomizedToolTip({ title }) {
    return (
       <LightTooltip title={<div>{parse(title)}</div>}>
            <IconButton sx={{padding: "0px", paddingLeft: "4px"}}>
                <img src={tooltip} alt="tooltip"/> 
            </IconButton>
        </LightTooltip>
    );
}
